import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineMultipleContinents extends TitleBase {
	private disciplineValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);

		return (
			this.indexableFilters.length >= 1 &&
			this.multiValueFilters.length >= 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.CONTINENT)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.disciplineValue} in selected continents`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.titlePortalType} in the field of ${this.disciplineValue}`,
			' in selected continents'
		);
	}
}
